<style scoped>
</style>

<template>
  <div class="section border border-1 border-dark pt-2 pb-2 ps-2">
    <span>
      <button class="btn btn-sm btn-primary" @click="waiting.panelOpened = !waiting.panelOpened">
        <i class="fa fa-bars"></i>
      </button>
      <h2 class="ms-2 header">参加待ちリスト ({{waiting.members.length}}/{{config.maxWaitingMemberCount}}名)</h2>
      <a class="ms-2 ext-link" target="_blank" href="https://scrapbox.io/mhrise-queque/lobby-waiting"><i class="fas fa-question-circle"></i></a>
    </span>
    <CollapseTransition class="mt-2 ps-4">
      <div v-show="waiting.panelOpened">
        <table>
          <tr>
            <th></th>  <!-- xボタン -->
            <th></th>  <!-- 参加ボタン -->
            <th>番号</th>  <!-- 連番 -->
            <th class="text-cell text-center">参加回数<br/>(合計)</th>
            <th class="text-cell text-center">参加回数<br/>(小計)</th>
            <th></th>  <!-- 上下矢印 -->
            <th class="text-cell">名前</th>
            <th class="text-cell">ハンター名</th>
            <th class="text-cell">メモ</th>
          </tr>
          <draggable v-model="waiting.members" tag="tbody" handle=".handle">
            <tr v-for="(m, i) in waiting.members" :key="i">
              <td>
                <button tabindex="-1" class="btn btn-sm btn-danger" v-on:click="onWaitingToCancelled(i)">
                  <i class="fas fa-times"></i>
                </button>
              </td>
              <td>
                <button class="btn btn-sm btn-primary"
                  v-bind:class="{ 'btn-secondary': !isJoinable(m) }"
                  v-on:click="onWaitingToJoined(i)">参加</button>
              </td>
              <td class="text-center">
                {{1 + i}}
              </td>
              <td class="text-center">
                {{m.grandTotalSortieCount}}
              </td>
              <td class="text-center">
                {{m.totalSortieCount}}
              </td>
              <td>
                <i class="px-2 fas fa-arrows-alt-v handle"></i>
              </td>
              <td class="text-cell">
                <span class="name">{{m.name}}</span>
              </td>
              <td class="text-cell" style="min-width: 100px;" v-on:click="onBeginEdit(i, 'hunterName')">
                <template v-if="i == editIndexes.hunterName">
                  <input ref="hunterName" type="text" v-model="m.hunterName"
                    v-on:keypress.enter.exact="editIndexes.hunterName = -1"
                    v-on:blur="onEndEdit(i, 'hunterName')"
                    >
                </template>
                <template v-else>
                  <span class="name">{{m.hunterName}}</span>
                </template>
              </td>
              <td class="text-cell" style="min-width: 100px;" v-on:click="onBeginEdit(i, 'memo')">
                <template v-if="i == editIndexes.memo">
                  <input ref="memo" type="text" v-model="m.memo"
                    v-on:keypress.enter.exact="editIndexes.memo = -1"
                    v-on:blur="onEndEdit(i, 'memo')"
                    >
                </template>
                <template v-else>
                  <span>{{m.memo}}</span>
                </template>
              </td>
            </tr>
          </draggable>
        </table>
        <div class="mt-2 ms-1">
          <table>
            <tr>
              <td>名前</td>
              <td>ハンター名</td>
              <td>メモ</td>
            </tr>
            <tr>
              <td><input ref="name" type="text" v-model="entry.name"
                v-on:keydown.ctrl.enter="onWaitingAdded"
                v-on:keydown.meta.enter="onWaitingAdded"
                /></td>
              <td><input type="text" v-model="entry.hunterName"
                v-on:keydown.ctrl.enter="onWaitingAdded"
                v-on:keydown.meta.enter="onWaitingAdded"
                /></td>
              <td><input type="text" v-model="entry.memo"
                v-on:keydown.ctrl.enter="onWaitingAdded"
                v-on:keydown.meta.enter="onWaitingAdded"
                /></td>
              <td><button class="btn btn-sm btn-primary" v-bind:class="{ 'btn-secondary': !canEntry }" v-on:click="onWaitingAdded">登録</button></td>
            </tr>
          </table>
        </div>
        <div class="mt-2">
          <button tabindex="-1" class="btn btn-sm btn-secondary"
            v-bind:class="{ 'btn-danger': isResettableCount }"
            v-on:click="onResetCount">参加回数(小計)をリセット</button>
          <label class="ms-2">
            <input tabindex="-1" id="resetCheck" type="checkbox" v-model="checkedToResetCount">
            リセット確認
          </label>
        </div>
      </div>
    </CollapseTransition>
    <!--
    <pre>{{$props}}</pre>
    <pre>{{$data}}</pre>
    -->
  </div>
</template>

<script>
import _ from 'lodash'
import { CollapseTransition } from "@ivanv/vue-collapse-transition"
import draggable from "vuedraggable"

export default {
  components: {
    draggable,
    CollapseTransition,
  },
  props: {
    config: { type: Object, required: true },
    joined: { type: Object, required: true },
    waiting: { type: Object, required: true },
    history: { type: Object, required: true },
  },
  data() {
    return {
      entry: {
        name: '',
        hunterName: '',
        memo: '',
      },
      editIndexes: {
        hunterName: -1,
        memo: -1,
      },
      checkedToResetCount: false,
    }
  },
  computed: {
    isLocked() {
      return this.joined.lockDuringQuest && this.joined.duringQuest
    },
    isJoinable() {
      return (m) => {
        if (this.isLocked) return false
        return this.joined.members.length < this.config.maxJoinedMemberCount
            && ! this.joined.members.some(x => x.name == m.name)
      }
    },
    canEntry() {
      return this.waiting.members.length < this.config.maxWaitingMemberCount
          && this.entry.name.trim() != ''
    },
    isResettableCount() {
      return this.waiting.members.some(m => 0 < m.totalSortieCount)
          || this.history.members.some(m => 0 < m.totalSortieCount)
    },
  },
  methods: {
    onWaitingToCancelled(i) {
      this.waiting.members.splice(i, 1)
      this.$emit('change', this.waiting)
    },
    onWaitingToJoined(i) {
      if (this.isLocked) return

      let n = this.joined.members.length
      if (this.config.maxJoinedMemberCount <= n) return
      
      let w = this.waiting.members[i]
      if (this.joined.members.some(m => m.name == w.name)) return

      this.$emit('add-to-joined', this.waiting.members[i])
      
      this.waiting.members.splice(i, 1)
      
      this.$emit('change', this.waiting)
    },
    onBeginEdit(i, fieldName) {
      this.editIndexes[fieldName] = i

      this.$nextTick(() => {
        this.$refs[fieldName][0].focus()
        this.$refs[fieldName][0].setSelectionRange(-1, -1)
      })
    },
    onEndEdit(i, fieldName) {
      this.editIndexes[fieldName] = -1
      this.$emit('change-entries', [this.waiting.members[i]])
    },
    onResetCount(){
      if (! this.isResettableCount) return
      if (! this.checkedToResetCount) return

      this.checkedToResetCount = false
      this.joined.members.forEach(m => m.totalSortieCount = 0)
      this.waiting.members.forEach(m => m.totalSortieCount = 0)
      this.history.members.forEach(m => m.totalSortieCount = 0)
      
      this.$emit('change-entries', this.waiting.members)

      this.$toasted.success('回数をリセットしました')
    },
    changeEntries(entries) {
      entries.forEach(entry => {
        this.waiting.members.filter(m => m.name == entry.name).forEach(m => {
          this.$set(m, 'hunterName', entry.hunterName)
          this.$set(m, 'memo', entry.memo)
          this.$set(m, 'grandTotalSortieCount', entry.grandTotalSortieCount)
          this.$set(m, 'totalSortieCount', entry.totalSortieCount)
        })
      })
    },
    onWaitingAdded() {
      if (this.entry.name == '') return

      let entry = _.clone(this.entry)
      entry.name = this.entry.name.trim()
      entry.hunterName = this.entry.hunterName.trim()
      entry.memo = this.entry.memo.trim()

      if (! this.addWaiting([entry])) return

      this.entry.name = ''
      this.entry.hunterName = ''
      this.entry.memo = ''
      this.$refs.name.focus()
    },
    addWaiting(entries) {
      let n =this.config.maxWaitingMemberCount - this.waiting.members.length
      if (n <= 0) return false

      let remains = entries.slice(0, n)
      let merges = getMergedEntries(remains, this.joined.members, this.waiting.members, this.history.members)

      // update memo
      merges.forEach(a => {
        this.waiting.members.forEach(m => {
          if (m.name == a.name) {
            this.$set(m, 'memo', a.memo)
          }
        })
      })

      this.$set(this.waiting, 'members', [...this.waiting.members, ...merges])

      this.$emit('add-waiting', merges)
      this.$emit('change-entries', merges)
      this.$emit('change', this.waiting)

      return true
    },
    addWaitingFromChat(entries) {
      let n = this.config.maxWaitingMemberCount - this.waiting.members.length
      let uniq = _.uniqBy(entries, e => e.name)
      let joinableEntries = uniq.slice(0, n)
      
      this.addWaiting(joinableEntries)
      joinableEntries.forEach(entry => this.$toasted.info(`参加待ちリストへ登録しました: ${entry.name}`, {duration: 10 * 1000}))

      let errors = uniq.slice(n)
      errors.forEach(error => {
        this.$toasted.error(`参加待ちリストへ登録できませんでした: ${error.name}`, { duration: 10 * 1000 })
      })
    },
    removeWaitingFromChat(entries) {
      entries.forEach(entry => {
        let i = _.findLastIndex(this.waiting.members, m => m.name == entry.name)
        if (0 <= i) {
          this.waiting.members.splice(i, 1)
          this.$toasted.info(`参加待ちリストからキャンセルしました: ${entry.name}`, {duration: 10 * 1000})
        }
      })
      
      this.$emit('change', this.waiting)
    },
    changeHunterNameFromChat(entries) {
      entries.forEach(entry => {
        let ms = this.waiting.members.filter(m => m.name == entry.name)
        if (ms.length == 0) return

        ms.forEach(m => {
          this.$set(m, 'hunterName', entry.hunterName)
        })
      })

      this.$emit('change-entries', this.waiting.members)
      this.$emit('change', this.waiting)
    },
  },
}

function getMergedEntries(entries, joinedMembers, waitingMembers, historyMembers) {
  return entries.map(entry => {
    // Use grandTotalSortieCount, totalSortieCount if remaining
    let exist = [
      joinedMembers.find(m => m.name == entry.name),
      waitingMembers.find(m => m.name == entry.name),
      historyMembers.find(m => m.name == entry.name),
    ].filter(m => !!m)[0]

    return {
      name: entry.name,
      hunterName: entry.hunterName != '' ? entry.hunterName : (exist?.hunterName || ''),
      memo: mergeMemo(entry, exist),
      grandTotalSortieCount: exist?.grandTotalSortieCount || 0,
      totalSortieCount: exist?.totalSortieCount || 0,
    }
  })
}

function mergeMemo(entry, history) {
  let entryMemo = (entry?.memo || '').trim()
  let historyMemo = (history?.memo || '').trim()

  if (historyMemo == '') return entryMemo
  if (0 <= historyMemo.indexOf(entryMemo)) return historyMemo
  return `${historyMemo} ${entryMemo}`
}
</script>
